
import Call from '../helpers/Network/Call';
import { test as testM3u8Url } from '../helpers/Network/M3u8';

import ExternalConfiguration from '../external-configuration';

export const States = {
  Pending: 'Pending',
  Testing: 'Testing',
  Tested: 'Tested',
};

const setMarkAsTest = unmarkedUrl => {   // NOTE la marca de test por query-string puede colisionar con parametros de query-string especializados como el sistema de tokenizacion interno que usaba Verizon
  const TestQueryKey = 'test';
  try {
    const decomposedUrl = new URL( unmarkedUrl);
    const queryParams = new URLSearchParams( decomposedUrl.search);
    queryParams.append( TestQueryKey, true);
    decomposedUrl.search = queryParams.toString();
    return `${decomposedUrl.href}`;   // equivalent `${decomposedUrl}`; or decomposedUrl.toString();
  } catch( error) {
    console.warn( 'controllers::SrcTester::setMarkAsTest - standar url parser failed to parse - error: ', error);
    try {
      const SearchSeparator = '?', ElementsSeparator = '&';
      const splitedUrl = unmarkedUrl.split( SearchSeparator);
      const searchString = splitedUrl[1] ?? '';
      const queryElements = searchString ? searchString.split( ElementsSeparator) : [];
      queryElements.push( TestQueryKey);
      splitedUrl[1] = queryElements.join( ElementsSeparator);
      return splitedUrl.join( SearchSeparator);
    } catch( error ) {
      console.error( 'controllers::SrcTester::setMarkAsTest - Imposible to set query-string test mark - error: ', error);
    }
  }
  return unmarkedUrl;
};

const testUrl = url => {
  const testsToApplyBasedOnEvaluationOfCorrespondentRegExpOnUrl = [{
    regExp: /\.mp(3|4)$/,   // progressive
    test: Call.head,
  },{
    regExp: /\.m3u8$/,      // hls
    test: testM3u8Url,
  },{
    regExp: /.*/,           // default
    test: Call.head,
  }];

  const testToApply = testsToApplyBasedOnEvaluationOfCorrespondentRegExpOnUrl.reduce( (prev,next) => {
    if( prev) return prev;
    if( next.regExp.exec( url)) return next.test;
    return prev;
  }, null) ?? (_ => null);         // on no coincidence do not apply any test

  return testToApply( setMarkAsTest( url));
};

const SrcTester = {

  test: async (configuration = {}) => {   // REVIEW  // playlist + startFrom?, Content?? 
    if( configuration.custom_3_playerConfiguration) {   // TODO mover a controlador especifico de custom_3_player y generalizar
      const { playlist = [] } = configuration.custom_3_playerConfiguration;
      const { errorMedia } = configuration.contentData;
      for( let i = 0; i < playlist.length; i++) {
        try {
          if( !playlist[i].file) throw { message: 'invalid media file' };
          await testUrl( playlist[i].file);
        } catch( _ ) {
          if( errorMedia) {
            try {
              if( !errorMedia.file) throw { message: 'invalid errorMedia file' };
              await testUrl( errorMedia.file);
              playlist[i] = errorMedia;
            } catch( _ ) {
              playlist[i].file = ExternalConfiguration.DefaultErrorVideo;
            }
          } else playlist[i].file = ExternalConfiguration.DefaultErrorVideo;
        }
        try {
          if( !playlist[i].image) throw { message: 'invalid media image' };
          await Call.head( setMarkAsTest( playlist[i].image));
        } catch( _ ) {
          playlist[i].image = ExternalConfiguration.DefaultImageDown;
        }
      }
    }
    return configuration;
  },

};

export default SrcTester;
